function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/* eslint-disable react/forbid-prop-types */
import _ from 'lodash';
import React from 'react';
import { Search, Button, Input, Icon, Popup, Menu } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { getRest } from "../../utils";

/**
 * Champ de recherche avec saisie assistée.
 *
 * @class SearchInput
 * @extends {React.Component}
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SearchInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SearchInput, _React$Component);
  /**
     * Creates an instance of SearchInput.
     *
     * @param {any} args constructor arguments
     * @memberof SearchInput
     */
  function SearchInput() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    /**
       *
       * @memberof SearchInput
       */
    _this.updateValue = function (value) {
      _this.setState({
        value: !_.isNil(value) ? value : ''
      });
    };
    /**
       *
       * @memberof SearchInput
       */
    _this.updateLoading = function (loading) {
      _this.setState({
        isLoading: loading
      });
    };
    /**
       *
       * @memberof SearchInput
       */
    _this.updateStartsWith = function (startsWith) {
      _this.setState({
        startsWith: startsWith
      });
    };
    /**
       * Reset the state of the component
       *
       * @memberof SearchInput
       */
    _this.resetComponent = function () {
      _.invoke(_this.props, 'onReset');
      _this.setState({
        isLoading: false,
        value: ''
      });
    };
    /**
       * Change la valeur dans le state à la sélection d'une ligne dans les résultats.
       *
       * @memberof SearchInput
       */
    _this.handleResultSelect = function (e, data) {
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        clearValueOnSelect = _this$props.clearValueOnSelect;
      if (!_.isNil(onSelect)) {
        if (clearValueOnSelect) {
          onSelect(e, data);
          _this.setState({
            value: '',
            isLoading: false
          });
        } else {
          _this.setState({
            value: onSelect(e, data),
            isLoading: false
          });
        }
      } else {
        _this.setState({
          isLoading: false
        });
      }
    };
    /**
       * Déclenche la recherche de résultat à la saisie dans le champ de recherche.
       *
       * @memberof SearchInput
       */
    _this.handleSearchChange = function (e, data) {
      var _this$props2 = _this.props,
        onBeforeChange = _this$props2.onBeforeChange,
        onChange = _this$props2.onChange,
        delay = _this$props2.delay;
      var startsWith = _this.state.startsWith;
      window.clearTimeout(_this.timeout);
      if (onBeforeChange) {
        onBeforeChange(e, data);
      }
      _this.timeout = window.setTimeout(function () {
        if (data.value.length < 1) {
          _this.resetComponent();
        } else {
          _this.setState({
            isLoading: true
          });
          if (!_.isNil(onChange)) {
            onChange(e, data, startsWith);
          }
        }
      }, delay);
      _this.setState({
        value: data.value
      });
    };
    /**
       * Change de type de recherche.
       *
       * @memberof SearchInput
       */
    _this.handleChangeType = function (e) {
      var _this$state = _this.state,
        startsWith = _this$state.startsWith,
        value = _this$state.value;
      _this.setState({
        startsWith: !startsWith
      }, function () {
        return _this.handleSearchChange(e, {
          value: value
        });
      });
    };
    /**
       * Change le type de recherche.
       *
       * @param startWith Type de recherche.
       * @memberof SearchInput
       */
    _this.changeType = function (e, startWith) {
      var value = _this.state.value;
      _this.setState({
        startsWith: startWith
      }, function () {
        return _this.handleSearchChange(e, {
          value: value
        });
      });
      _this.handleClose();
    };
    /**
       * Gère l'ouverture du menu de sélection du type de recherche
       *
       * @memberof SearchInput
       */
    _this.handleOpen = function () {
      _this.setState({
        isOpen: true
      });
    };
    /**
       * Gère la fermeture du menu de sélection du type de recherche
       *
       * @memberof SearchInput
       */
    _this.handleClose = function () {
      _this.setState({
        isOpen: false
      });
    };
    /**
       * Effectue le rendu d'un résultat avec le composant passé par l'utilisateur.
       *
       * @memberof SearchInput
       */
    _this.resultRenderer = function (props) {
      var ResultComponent = _this.props.resultComponent;
      return !_.isNil(ResultComponent) && /*#__PURE__*/_jsx(ResultComponent, Object.assign({}, props));
    };
    /**
       * Affiche le bouton de sélection du type de recherche.
       *
       * @memberof SearchInput
       */
    _this.renderSearchTypeButton = function () {
      var _this$state2 = _this.state,
        startsWith = _this$state2.startsWith,
        isOpen = _this$state2.isOpen;
      var type = startsWith ? 'Commence par' : 'Contient';
      return /*#__PURE__*/_jsxs(Button.Group, {
        children: [/*#__PURE__*/_jsx(Button, {
          content: type,
          onClick: _this.handleChangeType
        }, "searchTypeButton"), /*#__PURE__*/_jsx(Popup, {
          on: "click",
          open: isOpen,
          onClose: _this.handleClose,
          onOpen: _this.handleOpen,
          trigger: /*#__PURE__*/_jsx(Button, {
            icon: "bars"
          }, "searchTypeButton"),
          children: /*#__PURE__*/_jsxs(Menu, {
            fluid: true,
            vertical: true,
            secondary: true,
            children: [/*#__PURE__*/_jsx(Menu.Item, {
              onClick: function onClick(e) {
                _this.changeType(e, false);
              },
              children: "Contient"
            }), /*#__PURE__*/_jsx(Menu.Item, {
              onClick: function onClick(e) {
                _this.changeType(e, true);
              },
              children: "Commence par"
            })]
          })
        })]
      });
    };
    var defaultValue = _this.props.defaultValue;
    _this.state = {
      isLoading: false,
      value: _.isNil(defaultValue) ? '' : defaultValue,
      startsWith: false,
      isOpen: false
    };
    return _this;
  }

  /**
     *
     *
     * @memberof SearchInput
     */
  var _proto = SearchInput.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var startsWith = this.props.startsWith;
    this.setState({
      startsWith: startsWith
    });
  }

  /**
     *
     *
     * @param {*} prevProps
     * @memberof SearchInput
     */;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props3 = this.props,
      defaultValue = _this$props3.defaultValue,
      results = _this$props3.results,
      startsWith = _this$props3.startsWith;
    if (defaultValue !== prevProps.defaultValue) {
      this.updateValue(defaultValue);
    }
    if (results !== prevProps.results) {
      this.updateLoading(false);
    }
    if (startsWith !== prevProps.startsWith) {
      this.updateStartsWith(startsWith);
    }
  };
  /**
     * Render the component.
     *
     * @returns
     * @memberof SearchInput
     */
  _proto.render = function render() {
    var _this$props4 = this.props,
      results = _this$props4.results,
      noResultMessage = _this$props4.noResultMessage,
      searchTypeButton = _this$props4.searchTypeButton,
      input = _this$props4.input,
      loading = _this$props4.loading,
      readOnly = _this$props4.readOnly;
    var _this$state3 = this.state,
      isLoading = _this$state3.isLoading,
      value = _this$state3.value;
    var rest = getRest.apply(void 0, [SearchInput].concat(_.omit(this.props, 'onSelect')));
    var restInput = Object.assign({}, _.omit(input, 'icon'));
    var customIcon;
    var restIcon;
    if (value !== '') {
      restIcon = Object.assign({}, _.omit(input.icon, ['name', 'link', 'onClick']));
      customIcon = /*#__PURE__*/_jsx(Icon, Object.assign({}, restIcon, {
        name: "cancel",
        title: "Effacer la recherche",
        link: true,
        onClick: this.resetComponent
      }));
    } else {
      restIcon = Object.assign({}, _.omit(input.icon, 'name'));
      customIcon = /*#__PURE__*/_jsx(Icon, Object.assign({}, restIcon, {
        name: "search"
      }));
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [searchTypeButton && this.renderSearchTypeButton(), /*#__PURE__*/_jsx(Search, Object.assign({}, rest, {
        loading: !_.isNil(loading) ? loading : isLoading,
        onResultSelect: this.handleResultSelect,
        onSearchChange: this.handleSearchChange,
        results: results,
        value: value,
        resultRenderer: this.resultRenderer,
        noResultsMessage: noResultMessage,
        input: /*#__PURE__*/_jsx(Input, Object.assign({}, restInput, {
          icon: !readOnly && customIcon,
          readOnly: readOnly
        }))
      }))]
    });
  };
  return SearchInput;
}(React.Component);
/**
 * Prop types.
 */
SearchInput.handledProps = ["clearValueOnSelect", "defaultValue", "delay", "input", "loading", "noResultMessage", "onBeforeChange", "onChange", "onReset", "onSelect", "readOnly", "resultComponent", "results", "searchTypeButton", "startsWith"];
SearchInput.propTypes = {
  /** Liste des résultats trouvés. */
  results: PropTypes.arrayOf(PropTypes.object),
  /** Callback triggered when value is changing */
  onBeforeChange: PropTypes.func,
  /** Fonction à exécuter à chaque changement dans la saisie. */
  onChange: PropTypes.func,
  /** Fonction à exécuter à la sélection d'un résultat. */
  onSelect: PropTypes.func,
  /** Fonction à exécuter à la suppression de la saisie. */
  onReset: PropTypes.func,
  /** Message à afficher si aucun résultat n'a été trouvé. */
  noResultMessage: PropTypes.string,
  /** Composant de rendu d'une ligne de résultat. */
  resultComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** Délai entre chaque appel à la fonction de recherche */
  delay: PropTypes.number,
  /** Afficher le bouton de sélection du type de recherche */
  searchTypeButton: PropTypes.bool,
  /** Activer la recherche de type "commence par" */
  startsWith: PropTypes.bool,
  /** Personnalisation de l'input de recherche */
  input: PropTypes.object,
  /** Valeur par défaut à afficher dans le champs de recherche */
  defaultValue: PropTypes.string,
  /** Bool si on veut afficher le loader. */
  loading: PropTypes.bool,
  /** Bool searchInput en lecture seule */
  readOnly: PropTypes.bool,
  /* Remet le champs a vide quand on selectionne un tiers */
  clearValueOnSelect: PropTypes.bool
};

/**
 * Default props.
 */
SearchInput.defaultProps = {
  delay: 500,
  searchTypeButton: false,
  startsWith: false,
  input: {
    icon: {
      name: 'search'
    }
  },
  clearValueOnSelect: false
};
export default SearchInput;